import { Banner, LegacyStack, Modal, RadioButton } from "@shopify/polaris";
import { ExportIcon } from "@shopify/polaris-icons";
import { useCallback, useEffect, useState } from "react";
import { useExportOrdersMutation } from "../../store/store/slices/OrderRTK";
import { useLocation } from "react-router-dom";

const ExportOrderModal = ({
  openExportOrdersModal,
  closeModal,
  orders,
}: {
  openExportOrdersModal: boolean;
  closeModal: () => void;
  orders: string;
}) => {
  const location = useLocation();
  const [open, setOpen] = useState<boolean>(false);
  const [value, setValue] = useState<string>("");
  const [exportOrders, { isError, isLoading, isSuccess, error, data }] =
    useExportOrdersMutation();

  const close = () => {
    setOpen(() => false);
    closeModal();
  };
  const handleChange = useCallback((_: boolean, newValue: string) => {
    setValue(newValue);
  }, []);
  const onStartExportOrdersHandler = async () => {
    await exportOrders({ search: location.search, filter: value });
  };

  useEffect(() => {
    setOpen(() => openExportOrdersModal);
  }, [openExportOrdersModal]);

  let modalContent = null;
  if (isError) {
    modalContent = (
      <Banner tone="critical">
        <p>{error?.data?.errors[0]?.msg || "Something went wrong"}</p>
      </Banner>
    );
  } else if (isSuccess) {
    modalContent = (
      <Banner tone="success">
        <p>{data?.message}</p>
      </Banner>
    );
  } else {
    modalContent = (
      <LegacyStack vertical spacing="extraTight">
        <RadioButton
          label={`${orders} orders matching your search`}
          checked={value === "MATCHED_ORDERS" || !value}
          id="MATCHED_ORDERS"
          name="accounts"
          onChange={handleChange}
          disabled={isLoading}
        />
        <RadioButton
          label="All store orders"
          id="STORE_ORDERS"
          name="accounts"
          checked={value === "STORE_ORDERS"}
          onChange={handleChange}
          disabled={isLoading}
        />
        <Banner tone="info">
          Without a booking date, exports are limited to the last 90 days.
        </Banner>
      </LegacyStack>
    );
  }
  return (
    <Modal
      open={open}
      onClose={close}
      title="Select export order options"
      secondaryActions={[
        {
          content: "Export",
          onAction: onStartExportOrdersHandler,
          icon: ExportIcon,
          loading: isLoading,
          // disabled: isSuccess || isError || Number(orders) === 0,
        },
        {
          content: "Cancel",
          onAction: close,
        },
      ]}
    >
      <Modal.Section>{modalContent}</Modal.Section>
    </Modal>
  );
};

export default ExportOrderModal;
